import waitlistForm from '@/scripts/components/waitlistForm';

// pdpForm.js and CollectionProductCard.js import it directly; the global is kept for any
// app or legacy script that still calls window.waitlistForm.
window.waitlistForm = waitlistForm;
